import React, {  Fragment } from "react";
import { useParams, Navigate } from "react-router-dom";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import PartnerSection from "../../components/PartnerSection/PartnerSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import NavbarS4 from "../../components/NavbarS4/NavbarS4";
import PageTitle from "../../components/pagetitle/PageTitle";
import ScrollTextAnimation from "../../components/ScrollTextAnimation/ScrollTextAnimation";
import Logo from "../../images/logo2.png";
import SEO from "../../components/Seo";

const VALID_STATUS = ["ongoing", "completed"];

const PAGE_META = {
  ongoing: {
    title: "Ongoing Projects | LuxRock Realty",
    sub: "Projects currently under development",
    description:
      "Explore ongoing real estate projects by LuxRock Realty in Surat. Premium residential and commercial properties available for booking.",
    keywords:
      "ongoing projects in surat, under construction flats, new projects surat, LuxRock Realty ongoing projects",
  },
  completed: {
    title: "Completed Projects | LuxRock Realty",
    sub: "Successfully delivered projects",
    description:
      "View successfully completed real estate projects delivered by LuxRock Realty. Trusted property developer with quality construction.",
    keywords:
      "completed projects surat, delivered properties, ready to move flats surat, LuxRock Realty completed projects",
  },
};


const ProjectsByStatus = () => {
  const { status } = useParams();
  const isValid = VALID_STATUS.includes(status);



  // ❌ Invalid route → redirect
  if (!isValid) {
    return <Navigate to="/our-projects/ongoing" replace />;
  }

  return (
    <Fragment>
      <SEO
        title={PAGE_META[status].title}
        description={PAGE_META[status].description}
        keywords={PAGE_META[status].keywords}
      />

      <NavbarS4
        hclass={"wpo-site-header wpo-header-style-s11"}
        Logo={Logo}
        col1={"col-lg-3 col-md-3 col-3 d-lg-none dl-block"}
        col2={"col-lg-2 col-md-4 col-6"}
        col3={"col-lg-7 col-md-1 col-1"}
        col4={"col-lg-3 col-md-4 col-2"}
      />

      {/* ✅ Dynamic Page Title */}
      <PageTitle
        pageTitle={PAGE_META[status].title}
        pagesub={PAGE_META[status].sub}
      />

      <ScrollTextAnimation />

      <ProjectSection
        hclass={"wpo-project-section title section-padding pt-0"}
        status={status}
      />

      <PartnerSection hclass={"wpo-partners-section fade_bottom"} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ProjectsByStatus;
